// Demo payload converted from user-provided JSON
const payload = {
  questionSets: [
    {
      draw: 0,
      challenge: false,
      _id: {
        $oid: '69a570e66230f93f3835b470',
      },
      refCode: 'A',
      questions: [
        {
          format: 'image-dragdrop',
          gridSize: [],
          tokens: [],
          choices: [
            '/competition/uploads/mLNWhCLpS.png',
            '/competition/uploads/C7ih7ytsc.png',
            '/competition/uploads/rZwahKKZ6.png',
            '/competition/uploads/begTBHiFc.png',
            '/competition/uploads/1EKeKUnE4.png',
            '/competition/uploads/0SoiAAM_4.png',
            '/competition/uploads/TDEpsNaFV.png',
            '/competition/uploads/eiHu1bYey.png',
          ],
          matches: [
            'Test 1',
            'Test2',
            'Test 3',
            'Test 4',
            '',
            '',
            '',
            '',
          ],
          answers: [
            0,
            1,
            2,
            3,
          ],
          _id: {
            $oid: '69a570e66230f93f3835b471',
          },
          question: 'Test',
          img: null,
          answer: null,
          idioms: [],
        },
        {
          format: 'sentence-completion',
          gridSize: [],
          tokens: [],
          choices: [
            '床',
            '前',
            '明',
            '月',
            '光',
            '1',
            '2',
            '3',
            '5',
            '疑',
            '是',
            '地',
            '上',
            '霜',
          ],
          matches: [
            'Test 1',
            'Test 1',
            'Test 1',
            'Test 1',
            'Test 1',
            '',
            '',
            '',
            '',
            'Test 1',
            'Test 1',
            'Test 1',
            'Test 1',
            'Test 1',
          ],
          answers: [
            0,
            1,
            2,
            3,
            4,
            9,
            10,
            11,
            12,
            13,
          ],
          _id: {
            $oid: '69a69001fad0f89da508196e',
          },
          question: 'Test2',
          img: null,
          answer: null,
          idioms: [],
        },
        {
          format: 'idiom-fill',
          gridSize: [
            7,
            7,
          ],
          tokens: [
            '一',
            '籌',
            '莫',
            '展',
            '五',
            '花',
            '八',
            '門',
            '喺',
            '杯',
            '糟',
          ],
          choices: [],
          matches: [],
          answers: [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
          ],
          _id: {
            $oid: '69a7b751b3076ffc72f524cd',
          },
          question: 'Test',
          img: null,
          answer: null,
          idioms: [
            {
              start: [
                0,
                2,
              ],
              end: [
                3,
                2,
              ],
              pattern: [
                '一',
                '',
                '莫',
                '展',
              ],
              answers: [
                '一籌莫展',
              ],
              matches: [],
              _id: '69a80cdc08e5a288b5fc8d75',
              direction: 'vertical',
            },
            {
              start: [
                4,
                3,
              ],
              end: [
                4,
                6,
              ],
              pattern: [
                '五',
                '花',
                '',
                '門',
              ],
              answers: [
                '五花八門',
              ],
              matches: [],
              _id: '69a80cdc08e5a288b5fc8d76',
              direction: 'horizontal',
            },
          ],
        },
      ],
    },
  ],
};

export function buildImageDemo() {
  const q = payload.questionSets[0].questions.find(
    (x) => x.format === 'image-dragdrop',
  );
  if (!q) return { items: [], targets: [] };

  const items = q.choices.map((src, i) => ({
    id: `img${i}`,
    src,
    label: `Choice ${i}`,
  }));

  // For targets, show the match label (may be empty). If an expected answer exists
  // for that position, use the corresponding choice as expected image.
  const targets = q.matches.map((label, i) => ({
    id: `q${i}`,
    label: label || '',
    img: i < (q.answers || []).length ? q.choices[q.answers[i]] : null,
  }));

  return { items, targets, answers: q.answers || [] };
}

export function buildSentenceDemo() {
  const q = payload.questionSets[0].questions.find(
    (x) => x.format === 'sentence-completion',
  );
  if (!q) return { tokens: [], sentence: [] };

  const tokens = q.choices.map((text, i) => ({ id: `t${i}`, text }));

  // Build sentence slots grouped by contiguous answer indices.
  // If answers are like [0,1,2,3,4,9,10,11,12,13] this will create two groups
  // and insert a Chinese comma (，) between them, then a full stop (。).
  const answers = Array.isArray(q.answers) ? q.answers.slice().filter((v) => typeof v === 'number') : [];
  const uniqueSorted = Array.from(new Set(answers)).sort((a, b) => a - b);

  const groups = [];
  let current = null;
  for (let i = 0; i < uniqueSorted.length; i += 1) {
    const idx = uniqueSorted[i];
    if (!current) {
      current = [idx];
    } else {
      const last = current[current.length - 1];
      if (idx === last + 1) {
        current.push(idx);
      } else {
        groups.push(current);
        current = [idx];
      }
    }
  }
  if (current) groups.push(current);

  const sentence = [];
  let slotCounter = 0;
  groups.forEach((group, gi) => {
    group.forEach((origIdx) => {
      sentence.push({
        type: 'slot', id: `s${slotCounter}`, placeholder: `詞 ${slotCounter + 1}`, expectedIndex: origIdx,
      });
      slotCounter += 1;
    });
    if (gi < groups.length - 1) sentence.push({ text: '，' });
  });
  sentence.push({ text: '。' });

  return { tokens, sentence, answers: q.answers || [] };
}

export function buildIdiomsDemo() {
  const q = payload.questionSets[0].questions.find(
    (x) => x.format === 'idiom-fill',
  );
  if (!q) {
    return {
      tokens: [],
      gridSize: [5, 5],
      slots: [],
      answers: [],
    };
  }

  const tokens = Array.isArray(q.tokens)
    ? q.tokens.map((t, i) => ({ id: `tk${i}`, text: t }))
    : [];
  const rows = (q.gridSize && q.gridSize[0]) || 5;
  const cols = (q.gridSize && q.gridSize[1]) || 5;

  // build cellMap of pattern positions
  const cellMap = {};
  // expected char map and idiom slot indices summary
  const expectedMap = {};
  const idiomSummaries = [];
  (Array.isArray(q.idioms) ? q.idioms : []).forEach((idm) => {
    const start = Array.isArray(idm.start) ? idm.start : [0, 0];
    const end = Array.isArray(idm.end) ? idm.end : start;
    const dir = idm.direction || (start[0] === end[0] ? 'horizontal' : 'vertical');
    const pattern = Array.isArray(idm.pattern) ? idm.pattern : [];
    if (dir === 'horizontal') {
      const r = start[0];
      const sc = Math.min(start[1], end[1]);
      for (let i = 0; i < pattern.length; i += 1) {
        const c = sc + i;
        const k = `${r},${c}`;
        cellMap[k] = true;
        expectedMap[k] = pattern[i] || '';
      }
    } else {
      const c = start[1];
      const sr = Math.min(start[0], end[0]);
      for (let i = 0; i < pattern.length; i += 1) {
        const r = sr + i;
        const k = `${r},${c}`;
        cellMap[k] = true;
        expectedMap[k] = pattern[i] || '';
      }
    }
  });

  const slots = [];
  let idx = 0;
  for (let r = 0; r < rows; r += 1) {
    for (let c = 0; c < cols; c += 1) {
      const k = `${r},${c}`;
      if (cellMap[k]) {
        slots.push({
          r,
          c,
          id: `s${idx}`,
          idx,
          expected: expectedMap[k] || '',
        });
        idx += 1;
      }
    }
  }

  // Build idiom summaries: map each idiom to the corresponding slot index sequence
  (Array.isArray(q.idioms) ? q.idioms : []).forEach((idm) => {
    const start = Array.isArray(idm.start) ? idm.start : [0, 0];
    const end = Array.isArray(idm.end) ? idm.end : start;
    const dir = idm.direction || (start[0] === end[0] ? 'horizontal' : 'vertical');
    const pattern = Array.isArray(idm.pattern) ? idm.pattern : [];
    const slotIndices = [];
    if (dir === 'horizontal') {
      const r = start[0];
      const sc = Math.min(start[1], end[1]);
      for (let i = 0; i < pattern.length; i += 1) {
        const c = sc + i;
        const s = slots.find((x) => x.r === r && x.c === c);
        if (s) slotIndices.push(s.idx);
      }
    } else {
      const c = start[1];
      const sr = Math.min(start[0], end[0]);
      for (let i = 0; i < pattern.length; i += 1) {
        const r = sr + i;
        const s = slots.find((x) => x.r === r && x.c === c);
        if (s) slotIndices.push(s.idx);
      }
    }
    idiomSummaries.push({
      slotIndices,
      answers: Array.isArray(idm.answers) ? idm.answers.slice() : [],
    });
  });

  return {
    tokens,
    gridSize: [rows, cols],
    slots,
    answers: q.answers || [],
    idioms: idiomSummaries,
  };
}

export default { buildImageDemo, buildSentenceDemo, buildIdiomsDemo };
